module.exports = __webpack_public_path__ + "static/pyramids_chambers-2c94d4059fcfefec23d2ed9bcebd8911.png";